import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { getListEstados } from "../../api/getListEstados";
import { getListTipoLicenciaEstado } from "../../api/getListTipoLicenciaEstado";
import Modal from 'react-bootstrap/Modal';
import foodbrand from '../../assets/foodbrand@2x.png';
import Header from '../../Header/Header';
import Select from 'react-select';
import qr from '../../assets/qr.png';
import './style.css'
import './flags.css'

function TipoLicencia() {

    const navigate = useNavigate();
    const [onModalCompare, setOnModalCompare] = useState(false);
    const [onModalAdvertencia, setOnModalAdvertencia] = useState(false);
    const [show, setShow] = useState(false);
    const [showStatus, setShowStatus] = useState(null);
    const [showMessage, setShowMessage] = useState('');
    const [listEdo, setListEdo] = useState([]);
    const [tipoLicencia, setTipoLicencia] = useState([]);
    const [tipoLicenciaVal, setTipoLicenciaVal] = useState('');

    const isRunned = useRef(false);
    const [loading, setLoading] = useState(false);
    const [onSelectEmisor, setOnSelectEmisor] = useState(false);
    const [onSelectTipo, setOnSelectTipo] = useState(false);
    const [blContinue, setBlContinue] = useState(false);

    const [isInputReadOnlyEmisor, setIsInputReadOnlyEmisor] = useState(false);
    const [isInputReadOnly, setIsInputReadOnly] = useState(false);



    /**
     * Inicio del componete 
     * */

    useEffect(() => {

        if (isRunned.current) return;
        isRunned.current = true;

        async function createSession() {

            setLoading(true);

            const response = await getListEstados();

            if (response.status === 200) {
                const listEsAux = response.listEstados;
                listEsAux.map((data, idx) => (
                    listEdo.push({ value: data.init, label: data.nombreEstado })
                ))
            } else {
                setShow(true);
                setShowStatus(response.status);
                setShowMessage(response.message);
            }

            setLoading(false);

        }
        createSession();
    }, []);


    const handleChange = async (selectedOption) => {

        const setSelectedOption = selectedOption.value;
        const labelText = selectedOption.label;
        localStorage.setItem('emisor', labelText);
        localStorage.setItem('emisorISO', selectedOption.value);
        setOnSelectEmisor(true);
        setTipoLicencia([]);
        setTipoLicenciaVal('');

        const modelLicencia = {
            init: setSelectedOption,
            nombreEstado: labelText
        }

        const response = await getListTipoLicenciaEstado(modelLicencia);

        if (response.status === 200) {
            tipoLicencia.length = 0;
            setTipoLicencia(response.listTipoLicencia);
        } else {
            setShow(true);
            setShowStatus(response.status);
            setShowMessage(response.message);
        }
    };

    const handleChangeLic = async (selectedOption) => {
        setTipoLicenciaVal(selectedOption);
        const setSelectedOption = selectedOption.tipoLicencia;
        localStorage.setItem('tipoLicencia', setSelectedOption);
        setOnSelectTipo(true);
    };

    useEffect(() => {
        if (onSelectEmisor === true && onSelectTipo === true) {
            setBlContinue(true);
        } else {
            setBlContinue(false);
        }
    });

    const handleClose = async () => {
        setOnModalCompare(false);
    }

    const handleCloseError = async () => {
        setShow(false);
    }
    const onAdver = async () => {
        setOnModalAdvertencia(true);
    }

    const onAdverContinue = async () => {
        setOnModalCompare(false);
        setOnModalAdvertencia(false);
    }

    const onContinueTipo = async () => {
        navigate("/NumeroLic");
    }

    const style = {
        control: base => ({
            ...base,
            height: "52px !important",
            borderRadius: "0.375rem !important",
            boxShadow: "none !important",
            borderColor: "#c4cbd1 !important",
            "&:hover": {
                borderColor: "#c4cbd1 !important",
                background: "transparent"
            }
        })
    };

    const handleInputFocusEmisor = () => {
        setIsInputReadOnlyEmisor(true);
    }

    const handleInputFocus = () => {
        setIsInputReadOnly(true);
    }

    return (
        <>
            <div className='initBack_P2 animate__animated animate__fadeIn'>

                <Header imgBack={true} rutaBack='/HomeLicConducir' title='Licencia de Conducir' name='TipoLicencia' />

                <div className='containerRender'>

                    {loading ? (
                        <div className="spinner"></div>
                    ) : (
                        <div className="animate__animated animate__fadeIn">
                            <div className='containerInfo_P2'>
                                <div className='containerIdent_P2'>


                                    <div>
                                        <p className='txtNat_Licencia'>Emisor</p>
                                        <Select
                                            styles={style}
                                            className="select-wrapper"
                                            classNamePrefix="select"
                                            options={listEdo}
                                            onChange={handleChange}
                                            formatOptionLabel={listEdo => (
                                                <div className="containerEmisor">
                                                    <div className="estadoValue">{listEdo.value} {listEdo.label}</div>
                                                </div>
                                            )}
                                            placeholder="Seleccione la entidad emisora"
                                            isSearchable={false}
                                            readOnly={isInputReadOnlyEmisor}
                                            onFocus={handleInputFocusEmisor}
                                        />
                                    </div>
                                    <br />
                                    <div>
                                        <p className='txtNat_Licencia'>Conducir</p>
                                        <Select
                                            styles={style}
                                            className="select-wrapper"
                                            classNamePrefix="select"
                                            options={tipoLicencia}
                                            value={tipoLicenciaVal}
                                            onChange={handleChangeLic}
                                            formatOptionLabel={tipoLicencia => (
                                                <div className="containerEmisor">
                                                    {tipoLicencia.nombreLicencia !== '' ? (
                                                        <>
                                                            <div className="licenciaValue">{tipoLicencia.tipoLicencia} - {tipoLicencia.nombreLicencia}</div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="licenciaValueCom">{tipoLicencia.tipoLicencia}</div>
                                                        </>
                                                    )}

                                                </div>
                                            )}
                                            placeholder="Selecciona el tipo de licencia"
                                            isSearchable={false}
                                            readOnly={isInputReadOnly}
                                            onFocus={handleInputFocus}
                                        />
                                    </div>

                                    <hr className="line" />
                                    <div className='btnContinue'>
                                        {!blContinue ? (
                                            <>
                                                <button className='btnVer_P3'>
                                                    <span className='txtVer_P3'>Continuar</span>
                                                </button>
                                            </>
                                        ) : (
                                            <>
                                                <button className='button_P2 animate__animated animate__fadeIn' onClick={onContinueTipo}>
                                                    <span className='txtButton_P2'>Continuar</span>
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="footer">
                                <div className='imageContainer_P2'>
                                    <img src={foodbrand} className='imgFooter_P2' />
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>

            <Modal show={onModalCompare} onHide={handleClose} animation={false}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static">

                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <div className='txtModalCpvCompare'>Compartir/Share</div>
                        <div className='txtModalCpvCompareTitle'>Identificación Personal</div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <img src={qr} align="center" className='imgQr' />
                    <br />
                    <br />
                    <button className='button_Comp_Confirmar_P28'>
                        <span className='txtButton_P2'>Copiar</span>
                    </button>

                    <div className="spaceButton14" />
                    <button className='button_Comp_P28' onClick={onAdver}>
                        <span className='txtButton_Comp_P28'>Enviar</span>
                    </button>
                </Modal.Body>
            </Modal>
            <Modal show={onModalAdvertencia} onHide={handleClose} animation={true} centered backdrop="static">
                <Modal.Body className='backGroudModal'>
                    <div className='msjTitleModalDiv'>Advertencia</div>
                    <div className='msjErrorModal'>Está por compartir información de carácter personal.</div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='button_P2' onClick={onAdverContinue}>
                        <span className='txtButton_P2'>Continuar</span>
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal show={show} onHide={handleCloseError} animation={false} centered backdrop="static">
                <Modal.Body className='backGroudModal'>
                    <div className='msjTitleModalDiv'>Error {showStatus}</div>
                    <div className='msjErrorModal'>{showMessage}</div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='button_P2' onClick={handleCloseError}>
                        <span className='txtButton_P2'>Regresar</span>
                    </button>
                </Modal.Footer>
            </Modal>

        </>
    )
}

export default TipoLicencia
